import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const apiUrl = "https://ld5bm6e4ic.execute-api.eu-west-2.amazonaws.com/default/emergencyplan_lambda"

function AdminPage() {
  
  const navigate = useNavigate();
  const HandleHome = (event) => {
    event.preventDefault();
    navigate('/adminpage'); 
  };
  const SearchPerson = (event) => {
    event.preventDefault();
    navigate('/searchPerson'); 
  };
  const StartEvac = (event) => {
    event.preventDefault();
    navigate('/start'); 
  };

  const HandleAddPerson = (event) => {
    event.preventDefault();
    navigate('/addPersonOption');
  };

  const HandleAddPersonTemp = (event) => {
    event.preventDefault();
    navigate('/addPersonTemp');
  };

  const HandleAddPersonPerm = (event) => {
    event.preventDefault();
    navigate('/addPerson');
  };

  const HandleBulk = (event) => {
    event.preventDefault();
    navigate('/bulkupload');
  };
  const RemovePerson = (event) => {
    event.preventDefault();
    navigate('/removePersonOption'); 
  };
  const ModifyPerson = (event) => {
    event.preventDefault();
    navigate('/modify'); 
  };
  const emergencyPlan = (event) => {
    event.preventDefault();
    navigate('/emergencyPlan'); 
  };



  const DownloadTemplate = async (event) => {
    event.preventDefault();
    console.log("Template download");
    try {
      const userData = {
        type: "template"
      };
      const response = await axios.post(apiUrl, userData);
      console.log('Data sent to API:', response.data);
    } catch (error) {
      console.error('Error sending data to API:', error);
      alert('Failed to add person!');
    }
  };

  return (
    <Container className= "main-page-content">
      <Row>
        <Col>
          <img className="app-logo" src={Logo} width="400" height="50" alt="SmartEvac Logo" />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <h3>Emergency Plan</h3>
          <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="#home" onClick={HandleHome}>Home</Nav.Link>
                  <Nav.Link href="#link"onClick={SearchPerson} >Search</Nav.Link>
                  <Nav.Link href="#link" onClick={HandleAddPerson}>Add</Nav.Link>
                  <Nav.Link href="#link" onClick={RemovePerson}>Remove</Nav.Link>
                  <Nav.Link href="#link" onClick={ModifyPerson}>Modify</Nav.Link>
                  <Nav.Link href="#link" onClick={emergencyPlan}>Plan</Nav.Link>
                </Nav>
                <Nav className="ms-auto">
                  <Nav.Link href="#link" onClick={StartEvac}>Start Evacuation</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </Col>
      </Row>
      <br></br>
      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={6} lg={5}>
            <p className="Title">Download current plan</p>
            <button type="submit" className="login-button">Download</button>
            <br></br>
            <br></br>
            <br></br>
            
            <p className="Title">Upload new plan</p>
            <input className="login-button" type="file" id="excelFile" name="excelFile" />
            <br></br>
            <br></br>
            <br></br>

            <p className="Title">Download template plan</p>
            <button type="submit" onClick={DownloadTemplate} className="login-button">Download</button>
        </Col>
      </Row>

    </Container>
  );
}

export default AdminPage;
